import { PERK_REDEMPTION_TYPE } from "~constants/perks"
import CopyCell from "~components/CopyCell"

interface Props {
  redemptionType: PERK_REDEMPTION_TYPE
  response: any
}

enum CouponType {
  Code = "Code",
  URL = "URL",
}

interface CouponRedeemResponse {
  couponCode: string
  couponUrl?: string
}

interface ExternalLinkRedeemResponse {
  externalLink: string
}

const RedemptionResponse = ({ redemptionType, response }: Props) => {
  switch (redemptionType) {
    case PERK_REDEMPTION_TYPE.ExternalLink:
      return <ExternalLink externalLink={response.externalLink} />
    case PERK_REDEMPTION_TYPE.CouponList:
      return <CouponList couponCode={response} />
    default:
      return <></>
  }
}

const CouponList = (data: CouponRedeemResponse) => {
  const getCouponType = (coupon: CouponRedeemResponse) => {
    if (coupon.couponUrl) {
      return CouponType.URL
    }
    return CouponType.Code
  }

  return (
    <>
      {getCouponType(data) === CouponType.Code && (
        <>
          <span style={{ marginBottom: 15 }}>
            Code: {data.couponCode.couponCode}
          </span>
          <CopyCell
            classname={"green"}
            rowData={data.couponCode.couponCode}
            text={"Copy Code"}
          />
        </>
      )}
      {getCouponType(data) === CouponType.URL && (
        <CopyCell
          classname={"green"}
          rowData={data.couponUrl?.couponUrl}
          text={"Copy URL"}
        />
      )}
    </>
  )
}

const ExternalLink = (data: ExternalLinkRedeemResponse) => (
  <CopyCell classname={"green"} rowData={data.externalLink} text={"Copy URL"} />
)

export default RedemptionResponse
